angular.module('gym.bulkUpdates', []).config(["$stateProvider", function($stateProvider) {
  return $stateProvider.state('gym.bulkUpdates', {
    url: '/bulk_update',
    abstract: true,
    template: '<ui-view>'
  }).state('gym.bulkUpdates.list', {
    url: '/bulk_updates',
    controller: 'BulkUpdatesListCtrl',
    template: require('templates/gyms/bulk_updates/list.html.slim')
  }).state('gym.bulkUpdates.show', {
    url: '/bulk_updates/:id',
    controller: 'ShowBulkUpdateCtrl',
    template: require('templates/gyms/bulk_updates/show/show.html.slim'),
    resolve: {
      meta: ["$stateParams", "$http", function($stateParams, $http) {
        var url;
        url = `/gyms/${$stateParams.gymId}/bulk_update/bulk_updates/meta`;
        return $http.get(url).then(function(response) {
          return response.data;
        });
      }],
      bulkUpdate: ["$stateParams", "$http", function($stateParams, $http) {
        var url;
        url = `/gyms/${$stateParams.gymId}/bulk_update/bulk_updates/${$stateParams.id}`;
        return $http.get(url).then(function(response) {
          return response.data;
        });
      }]
    }
  });
}]);
